interface LogoProps {
  size?: number;
  className?: string;
}

/** Marca abstrata: barras ascendentes (crescimento/finanças) sobre um chip ink — não usa iniciais nem gradiente genérico. */
export function Logo({ size = 36, className }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      className={className}
      role="img"
      aria-label="ControleNext"
    >
      <rect width="36" height="36" rx="10" fill="var(--ink)" />
      <rect x="8.5" y="20.5" width="4.5" height="7.5" rx="1.3" fill="var(--accent-solid)" opacity="0.5" />
      <rect x="15.75" y="14.5" width="4.5" height="13.5" rx="1.3" fill="var(--accent-solid)" opacity="0.82" />
      <rect x="23" y="7.5" width="4.5" height="20.5" rx="1.3" fill="var(--accent)" />
    </svg>
  );
}
